import { useEffect, useState } from 'react';
import {
  Box, CircularProgress, makeStyles,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  containerSpinner: {
    width: '100%',
    height: window.innerHeight,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textSpinner: {
    fontFamily: 'Raleway',
    fontWeight: 400,
    width: 400,
    textAlign: 'center',
    margin: theme.spacing(3, 0),
    fontSize: 20,
    color: theme.palette.text.default,
  },
}));
function LoadingWorld() {
  const classes = useStyles();
  const [text, setText] = useState('');
  const phrasesInterval = () => {
    const phrases = [
      'Kami te ayudará a contactar con un mentor',
      'Las notas que agregues te ayudarán con el refuerzo de tu aprendizaje',
    ];
    const random = Math.floor(Math.random() * 2);
    return setText(phrases[random]);
  };
  useEffect(() => {
    const loopPhrase = setInterval(phrasesInterval, 900);
    return () => {
      clearInterval(loopPhrase);
    };
  }, []);
  return (
    <Box className={classes.containerSpinner}>
      <CircularProgress color="secondary" size={120} />
      <Typography className={classes.textSpinner}>{text}</Typography>
    </Box>
  );
}

export default LoadingWorld;
